<template>
  <div class="body-container second-theme">
    <second-header-child
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
    <second-body-child
      :newSection="newSection"
      :newItem="newItem"
      :listSections="listSections"
      :restaurant="restaurant ? restaurant : {}"
      :currentTab="currentTab"
      :setCurrentTab="setCurrentTab"
      :handleChangeShowSub="handleChangeShowSub"
      :disponibleItem="disponibleItem"
      :showItem="showItem"
      :currentCurrency="currentCurrency"
      :addToCart="addToCart"
    />

    <second-footer-child
      :currentLang="currentLang"
      :newItem="newItem"
      :restaurant="restaurant ? restaurant : {}"
    />
  </div>
</template>

<script>
import secondHeader1 from "../headers/second-header.vue";
import secondBody1 from "../body/second-body.vue";
import footerSecond1 from "../footer/footer-second.vue";
export default {
  components: {
    "second-header-child": secondHeader1,
    "second-body-child": secondBody1,
    "second-footer-child": footerSecond1,
  },
  props: [
    "currentLang",
    "newItem",
    "restaurant",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "addItem",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "currentCurrency",
    "addToCart",
  ],
  data() {
    return {};
  },
  methods: {},
  watch: {},
  mounted() {
    console.log("*********************HEEEY*************************");
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,400italic,600,600italic,700,700italic");
@import url("http://fonts.googleapis.com/css?family=Montserrat:400,200,300,500,600,700,800");
@import url("https://fonts.googleapis.com/css?family=Allura");
@import url("https://fonts.googleapis.com/css?family=Varela+Round");
@import url("https://fonts.googleapis.com/css?family=Lora:400,400i,700,700i");
body {
  height: auto;
}
.body-container.second-theme {
  /* width: 100%; */
  /* background-color: #f0f0f0; */
  /* overflow: hidden; */
  /* padding: 0px; */
  /* margin: 0px; */
  font-family: "Varela Round", Arial, Helvetica, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #ddd;
  line-height: 1.9em;
  padding: 0;
  background: #606060;
  /* display: none; */
}
@media screen and (max-width: 580px) {
  .body-container.second-theme {
    width: 100%;
  }
}
</style>
